export const baseUrl = "https://www.backend.tableapp.cf/FoodieApi";

// export const baseUrl = "http://dcs.xge.mybluehost.me/FoodieApi/";
